module.exports = "<p-dialog header=\"Authentication\" [draggable]=\"false\" [(visible)]=\"displayDialog\" modal=\"modal\" showEffect=\"fade\">\n  <div class=\"strategy-list-container\">\n    <div class=\"strategy-container\" *ngFor=\"let authStrategy of getStrategies()\">\n      <h4>{{authStrategy.getId()}}</h4>\n      <auth-strategy [strategy]=\"authStrategy\"></auth-strategy>\n      <div class=\"auth-border-bottom\"></div>\n    </div>\n  </div>\n</p-dialog>\n\n<button class=\"button-auth\" *ngIf=\"getStrategies().length > 0\" (click)=\"showDialog()\">Authentication</button>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/auth/auth.html
 ** module id = 750
 ** module chunks = 0
 **/